module.exports = __webpack_public_path__ + "img/logo-vcoin.79cf8c67.png";